import { setupLayout } from 'common.js';
import { render } from "react-dom";
import 'jquery.js';
import 'jquery-components/bootstrap-dropdown';
import TourSearchContainer from './compoments/TourSearchContainer';
import { NewTourSearchProps } from './compoments/TourSearch';

/**
 * 
 * @param {NewTourSearchProps} props
 */
export function setupNewTourSearch(props) {
    const root = TourSearchContainer(props);
    render(root, document.getElementById('new-tour-search'));
}

export { setupLayout };
